export const name = 'privilegesService';
export default function privilegesService($http, $log) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  var vm = this;

  let functionsToExport = {};

  functionsToExport.getPrivileges = function(){
    let functionName = "privilegesService.getPrivileges";
    $log.log(angular.toJson({functionName:functionName, action:'function called'}));

    let url = "/api/composer-service/v1/special-user/permissions";

    return $http({method: 'GET', url: url, headers: {'Accept':'application/json'}}).then(response => {
      return response.data;
    });
  };

  functionsToExport.adminRefund = function(refundQuota, description = "No Description"){
    let functionName = "privilegesService.adminRefund";
    $log.log(angular.toJson({functionName:functionName, action:'function called'}));

    let url = "/api/composer-service/v1/composer/ecommerce/org-count/refund";

    let data={
      amount:refundQuota,
      description:description
    };

    return $http({method: 'POST',data:data , url: url, headers: {'Accept':'application/json','Content-Type':'application/json'}}).then(response => {
      return response.data;
    });
  };

  functionsToExport.getAdminRefunds = function(response){
    let functionName = "privilegesService.getAdminRefunds";
    $log.log(angular.toJson({functionName:functionName, action:'function called'}));

    let url = "/api/composer-service/v1/composer/ecommerce/org-count/refund";

    return $http({method: 'GET', url: url, headers: {'Accept':'application/json'}}).then(response => {
      return response.data;
    });
  };

  return functionsToExport;
}
